import omit from "lodash/omit";
import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const dependentListService = (params: Types.DependentListRequest) =>
  RestAPIClient.call<Types.DependentListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List.replace("{employeeId}", params.employeeId.toString()),
    config: {
      requireAuthentication: true,
      params: omit(params, ["employeeId"]),
    },
  });

export const dependentCreateService = (params: Types.DependentCreateRequest) =>
  RestAPIClient.call<Types.Dependent>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create.replace("{employeeId}", params.employeeId.toString()),
    config: {
      requireAuthentication: true,
    },
    data: omit(params, ["employeeId"]),
  });

export const dependentUpdateService = (params: Types.DependentUpdateRequest) =>
  RestAPIClient.call<Types.Dependent>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update.replace(
      "{employeeId}",
      params.employeeId.toString()
    )}/${params.id}`,
    config: {
      requireAuthentication: true,
    },
    data: omit(params, ["employeeId", "id"]),
  });

export const dependentDetailService = ({
  employeeId,
  id,
}: {
  employeeId: number;
  id: number;
}) =>
  RestAPIClient.call<Types.Dependent>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Update.replace("{employeeId}", employeeId.toString())}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });
